const BASE = 'http://jinri.sansg.com/'

export const filterHref = value => {
  return `/#/product/${value.TYPEID}/${value.ID}`
}

export const bgimgFilter = (value, img) => {
  if (value === '') {
    const url = img || '/images/progroup-2.png'
    return `background-image: url(${url});`
  }

  if (value[0] === '/') {
    return `background-image: url(${value});`
  }

  return `background-image: url(${BASE}upload/${value});`
}

export const imgFilter = (value, img) => {
  if (value === '') {
    return img || '/images/progroup-2.png'
  }

  if (value[0] === '/') {
    return value
  }

  return `${BASE}upload/${value}`
}

export const dateFilter = value => {
  if (value) {
    return value.split(' ')[0]
  }
  return ''
}

export const filterDay = value => {
  if (value) {
    return value.split(' ')[0].split('-')[2]
  }
  return ''
}

export const filterMonth = value => {
  if (value) {
    return value.split(' ')[0].substr(0, 7)
  }
  return ''
}

export const substrFilter = (value, len = 100) => {
  value = value.replace(/<\/?[^>]*>/g, '') // 去除HTML tag
  value = value.replace(/[ | ]*\n/g, '\n') // 去除行尾空白
  value = value.replace(/&nbsp;/ig, '') // 去掉&nbsp;

  if (value.length > len) {
    return `${value.substr(0, len)}...`
  }
  return value
}
